import { render, staticRenderFns } from "./FormatsSelector.vue?vue&type=template&id=10fd2617&scoped=true&"
import script from "./FormatsSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatsSelector.vue?vue&type=style&index=0&id=10fd2617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd2617",
  null
  
)

export default component.exports